import { trackEvent as t } from '../track';

export const activityFeed = {
  viewFeed: () => t('[Activity Feed] View'),
};
